import { Link, useSearchParams } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BookingRequestForm from '../components/BookingRequestForm';
import AvailableRooms from '../components/AvailableRooms';
import { useSiteContent } from '../context/SiteContent';
import SiteImage from '../components/SiteImage';
import './Booking.css';

export default function Booking() {
  const [searchParams] = useSearchParams();
  const { site } = useSiteContent();
  const initialValues = {
    checkIn: searchParams.get('checkIn') || '',
    checkOut: searchParams.get('checkOut') || '',
    guests: searchParams.get('guests') || '1'
  };

  return (
    <main className="booking-experience">
      <section className="page-hero page-hero-booking">
        <div className="page-width">
          <span className="eyebrow">Start planning</span>
          <h1>Booking &amp; Availability</h1>
          <p>We’d be delighted to hear about your plans.</p>
        </div>
      </section>
      <div className="page-width booking-intro">
        <div className="booking-intro-copy">
          <span className="booking-seal"><SafeIcon name="Calendar" /></span>
          <span className="eyebrow">Your next stay starts here</span>
          <h2>Let’s find the right dates for you.</h2>
          <p>Booking requests are not confirmed until the guest house confirms availability. Send us your dates and we will get back to you.</p>
          <div className="booking-intro-points">
            <span><SafeIcon name="CheckCircle" /> Browse available rooms</span>
            <span><SafeIcon name="MessageCircle" /> Hear back from our team</span>
          </div>
        </div>
        <div className="booking-intro-photo">
          <SiteImage src={site.rooms[0]?.image} alt={site.rooms[0]?.alt || 'Guest house room interior'} />
          <span><SafeIcon name="MapPin" /> Negombo, Sri Lanka</span>
        </div>
      </div>
      <section className="booking-page page-width" aria-label="Availability and booking enquiry">
        <div className="booking-page-heading">
          <span className="eyebrow">Stay your way</span>
          <h2>Explore your options</h2>
          <p>Find a room for your dates, then send an enquiry to our team.</p>
        </div>
        <AvailableRooms checkIn={initialValues.checkIn} checkOut={initialValues.checkOut} guests={initialValues.guests} />
        <div className="booking-enquiry-layout">
          <div className="booking-enquiry-aside">
            <span className="booking-aside-icon"><SafeIcon name="Mail" /></span>
            <span className="eyebrow">A personal welcome</span>
            <h2>Tell us about your stay.</h2>
            <p>Share your dates and details below. Our team will review your enquiry and contact you about availability.</p>
            <div className="booking-aside-rule" />
            <p><SafeIcon name="Info" /> This is an enquiry, not a confirmed reservation.</p>
            <Link className="text-link booking-contact-link" to="/contact">Contact details <SafeIcon name="ArrowRight" /></Link>
          </div>
          <BookingRequestForm initialValues={initialValues} />
        </div>
      </section>
    </main>
  );
}